export default "__VITE_ASSET__35Pc50jt__"